import React, { useEffect } from 'react';

const adsLeftDesktopFirst = "7401846518";
const adsAboveCalcMobile = "8355835530"
const AdComponent = ({ adSlot }) => {
    useEffect(() => {

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
        catch (e) {
        }

    }, []);

    return (
        <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-7107245842042491"
            data-ad-slot={adSlot}
            data-ad-format="auto"
            data-full-width-responsive="true"
        ></ins>
    );
};



export const AdsLeftDesktopFirst = () => (

    <div style={{ height: '280px', backgroundColor: 'white' }}>
        <AdComponent adSlot={adsLeftDesktopFirst} />
    </div>
);
export const AdsAboveCalcMobile = () => (

    <div style={{ height: '280px', backgroundColor: 'white' }}>
        <AdComponent adSlot={adsAboveCalcMobile} />
    </div>
);

export const HomePageUpperCenterAds = () => (
    <div></div>
);